import { render, staticRenderFns } from "./ExportRecordCard.vue?vue&type=template&id=016c939f&"
import script from "./ExportRecordCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExportRecordCard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports